module.exports = __webpack_public_path__ + "static/media/complete.c2993dd7.svg";